module.exports = __webpack_public_path__ + "media/images/common/main_hr-7abadca043f96591310beab226166d30.gif";